import React from 'react';

interface ChartMetadataWidgetProps {
    metadata: Record<string, any> | undefined;
}

const ChartMetadataWidget: React.FC<ChartMetadataWidgetProps> = ({ metadata }) => {
    if (!metadata) {
        return null;
    }

    const formatNumber = (value: any): string => {
        if (typeof value === 'number') {
            return value.toLocaleString();
        }
        return String(value);
    };

    return (
        <div className="chart-metadata">
            {metadata.TotalPackingBoxes !== undefined && (
                <div className="chart-metadata__item">
                    <p className="xsmall">Total Packing Boxes</p>
                    <p className='chart-metadata__item--stat'>{formatNumber(metadata.TotalPackingBoxes)}</p>
                </div>
            )}
            {metadata.TotalVolumeInStore !== undefined && (
                <div className="chart-metadata__item">
                    <p className="xsmall">Total Volume in Store</p>
                    <p className='chart-metadata__item--stat'>{formatNumber(metadata.TotalVolumeInStore)}</p>
                </div>
            )}
            {metadata.TotalTypesInStore !== undefined && (
                <div className="chart-metadata__item">
                    <p className="xsmall">Total Types in Store</p>
                    <p className='chart-metadata__item--stat'>{formatNumber(metadata.TotalTypesInStore)}</p>
                </div>
            )}
            {metadata.TotalRanges !== undefined && (
                <div className="chart-metadata__item">
                    <p className="xsmall">Total Ranges</p>
                    <p className='chart-metadata__item--stat'>{formatNumber(metadata.TotalRanges)}</p>
                </div>
            )}
            {metadata.TotalYears !== undefined && (
                <div className="chart-metadata__item">
                    <p className="xsmall">Total Years</p>
                    <p className='chart-metadata__item--stat'>{formatNumber(metadata.TotalYears)}</p>
                </div>
            )}
        </div>
    );
};

export default ChartMetadataWidget;
